export const getInputAutofillStyle = (backgroundColor: string) => ({
  boxShadow: `0 0 0 1000px ${backgroundColor} inset`,
});
